import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useIsDocumentUploadEnabled = () => {
  return useFeatureFlag(FeatureFlagDeclarations.isDocumentUploadEnabled);
};
